<div class="card shadow-sm  summary-container">
    <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <span class="h6 font-semibold text-muted text-sm d-block mb-2">Financial Summary</span>
            <div class="d-flex align-items-center ms-auto gap-2">
                <select class="form-select form-select-sm text-dark bg-white" style="width: 180px; height: 35px;"
                    [(ngModel)]="selectedMonth" (change)="onMonthChange()">
                    <option *ngFor="let month of months" [value]="month.value">
                        {{ month.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="d-flex gap-3">
            <!-- Total Revenue -->
            <div class="flex-fill border rounded">
                <div class="text-center">
                    <ng-container *ngIf="isLoadingSummary; else revenueContent">
                        <div class="spinner-border text-primary mt-4" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </ng-container>
                    <ng-template #revenueContent>
                        <div class="fs-1 mb-2">💰</div>
                        <h6 class="text-uppercase fw-bold mb-1">Total Revenue</h6>
                        <p class="fs-4 fw-semibold text-dark mb-0">
                            {{currencyFormat}} {{ revenue }}
                        </p>
                    </ng-template>
                </div>
            </div>

            <!-- Total Payout -->
            <div class="flex-fill border rounded">
                <div class="text-center">
                    <ng-container *ngIf="isLoadingSummary; else payoutContent">
                        <div class="spinner-border text-primary mt-4" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </ng-container>
                    <ng-template #payoutContent>
                        <div class="fs-1 mb-2">💸</div>
                        <h6 class="text-uppercase fw-bold mb-1">Total Payout</h6>
                        <p class="fs-4 fw-semibold text-dark mb-0">
                            {{currencyFormat}} {{ payout }}
                        </p>
                    </ng-template>
                </div>
            </div>

            <!-- Gross Margin -->
            <div class="flex-fill border rounded">
                <div class="text-center">
                    <ng-container *ngIf="isLoadingSummary; else marginContent">
                        <div class="spinner-border text-primary mt-4" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </ng-container>
                    <ng-template #marginContent>
                        <div class="fs-1 mb-2">📈</div>
                        <h6 class="text-uppercase fw-bold mb-1">Gross Margin</h6>
                        <p class="fs-4 fw-semibold text-dark mb-0">
                            {{currencyFormat}} {{ margin }}
                            <span class="text-muted small">({{ marginPercent }}%)</span>
                        </p>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>